import { Routes } from "@angular/router";
import { AuthGuard } from "../../guards/auth.guard";

export const content: Routes = [
  {
    path: "groups",
    loadChildren: () => import("../../components/groups/groups.module").then((m) => m.CompaniesModule),
    canActivate: [AuthGuard]
  },
  {
    path: "modules",
    loadChildren: () => import("../../components/modules/modules.module").then((m) => m.ModulesModule),
    canActivate: [AuthGuard]
  },
  {
    path: "setup",
    loadChildren: () => import("../../components/setup/setup.module").then((m) => m.SetupModule),
    canActivate: [AuthGuard]
  },
  {
    path: "hr",
    loadChildren: () => import("../../components/hr/hr.module").then((m) => m.HrModule),
    canActivate: [AuthGuard]
  },
  {
    path: "accounting",
    loadChildren: () => import("../../components/accounting/accounting.module").then((m) => m.AccountingModule),
    canActivate: [AuthGuard]
  },
  {
    path: "settings",
    loadChildren: () => import("../../components/settings/settings.module").then((m) => m.SettingsModule),
    canActivate: [AuthGuard]
  },
  {
    path: "documents",
    loadChildren: () => import("../../components/documents/documents.module").then((m) => m.DocumentsModule),
    canActivate: [AuthGuard]
  },
  {
    path: "dashboard",
    loadChildren: () => import("../../components/dashboard/dashboard.module").then((m) => m.DashboardModule),
    canActivate: [AuthGuard]
  },
  {
    path: "error",
    loadChildren: () => import("../../components/error/error.module").then((m) => m.ErrorModule),
    canActivate: [AuthGuard]
  },
  {
    path: "my-goperform",
    loadChildren: () => import("../../components/my-goperform/my-goperform.module").then((m) => m.MyGoperformModule),
    canActivate: [AuthGuard]
  },
  {
    path: "subscriptions",
    loadChildren: () => import("../../components/subscriptions/subscriptions.module").then((m) => m.SubscriptionsModule),
    canActivate: [AuthGuard]
  },
  {
    path: "training-videos",
    loadChildren: () => import("../../components/videos/videos.module").then((m) => m.VideosModule),
    canActivate: [AuthGuard]
  }
];
